<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>

    <List :data-val="valData" @child-event='getListVal' @save-event="saveFile"/>
    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
            type="primary"> 提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from '../components/Date.vue';
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import List from '../components/ListCopy.vue';
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import {getAgentInfo, getRelation, getUserInfo} from "@/api/employee"
import { getDepartmentInfo ,getDepartmentRelationByName } from "@/api/department";
import {
  uploadFile,
  getFileInfoByMediaId
} from '@/api/file'

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates,
    List
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
      valData: {
        TotalCount: 0,
        listTitle: [
          {
            type: 'selection',
            width: 45,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '序号',
            key: 'AssetsId',
            width: 220,
            disabled: true
          },
          {
            title: '资产编号',
            key: 'AssetsCode',
            width: 120,
            disabled: true
          },
          {
            title: '资产名称',
            key: 'AssetsName',
            width: 220,
            disabled: true
          },
          {
            title: '资产状态',
            key: 'AssetsStateName',
            width: 120,
            disabled: true
          },
          {
            title: '价格',
            key: 'AssetsPrice',
            width: 180,
            disabled: true
          },
          {
            title: '入库时间',
            key: 'InStoreTime',
            width: 180,
            disabled: true
          }
        ],
        listData: [],
        isDisabled: false
      },
      fromData:[]
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(null);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "single", // 必填，选择模式，single表示单选，multi表示多选
            type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var depart = res.result.departmentList[0];
              dataVal.Values = [];
              dataVal.Values.push([depart.id, depart.name]);
              dataVal.Value = depart.name;
            }
          }
      );
    },
    tableOperation (val, type, datas) {
      this.tableoperation(val, type, datas, this);
    },
    getSelectorVal(val, name) {
    },
    getListVal: async function(data, type) {
      if(type === "changeData"){
        this.fromData = data;
        console.log("data")
        console.log(data)
      }
    },
    saveFile :async function(file,type){
      var that = this
      if (type === "save"){
        let files = [file]
        let formData = new FormData()
        formData.append('category', 'settingPic')
        for (var j = 0; j < files.length; j++) {
          if ((files[j].size / 1024 / 1024) > 20) {
            that.$message.info('文件大小不能超过20M!');
            return;
          }
          formData.append('file', files[j]);
        }
        console.log(formData)
        let results = []
        let newFileNames;
        await uploadFile(formData).then((res) => {
          that.$message.info('上传成功!');
          var fileNames = []
          for (var i = 0; i < res.Body.length; i++) {
            fileNames.push({
              "key": res.Body[i].fileName,
              "val": res.Body[i].MediaId,
              "time": res.Body[i].CreatedAt,
              'type': res.Body[i].type
            });
            results.push([res.Body[i].MediaId]);
          }
          newFileNames = fileNames
        });
        that.templateData.TemplateContent.Controls.forEach(item => {
          if (item.Property.Title[0].Text === "附件"){
            item.Values = results
            item.fileNames = newFileNames
          }
        })
      }
    },
    getTextVal() {},
    getTemplate: async function () {
      var that = this;
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      if(departName.indexOf("运维部") === -1){
        this.Message({
          message: '没有申请权限(只有运维部可申请)',
          type: 'error',
          duration: 2000
        });
        this.isDisabled=true;
      }
      getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++) {
          let item = controls.TemplateContent.Controls[i];
          if (item.Property.Title[0].Text === "申请人"){
            item.addIsShow = false
            let children = item.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === "名字"){
                child.Value = that.logInfo.EmpName
              }
              if (child.Property.Title[0].Text === "工号"){
                child.Value = that.logInfo.EmpNo
              }
              if (child.Property.Title[0].Text === "部门"){
                child.Value = that.logInfo.DeptName
              }

            })
          }
          if (item.Property.Title[0].Text === "申请内容"){
            item.IsShow = false
          }
          if (item.Property.Title[0].Text === "附件"){
            item.IsShow = false;
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }

      let that = this
      let tableData = []
      if(that.fromData==null||that.fromData.length<=0){
        this.listLoading = false;//隐藏加载
        that.Message({
          message: "请导入资产信息",
          type: 'error',
          duration: 3 * 1000
        });
        return;
      }
      var isDelete = false;
      for(let i = this.templateData.TemplateContent.Controls.length-1;i>=0;i--){
        let data = this.templateData.TemplateContent.Controls[i];
        if(data.Property.Title[0].Text.indexOf("申请内容")>-1){
          if(isDelete){
            this.templateData.TemplateContent.Controls.splice(i,1);
          }else{
            isDelete = true;
          }
        }
      }
      this.templateData.TemplateContent.Controls.forEach((item,index)=>{
        if (item.Property.Title[0].Text.indexOf("申请内容")>-1) {
          if(that.fromData!=null){
            tableData = that.convertInTable(that.fromData,item);
          }else{
            if(item.Config.Table.Children.length == 0 || !item.IsShow ){
              this.listLoading = false;//隐藏加载
              that.Message({
                message: "请导入资产信息",
                type: 'error',
                duration: 3 * 1000
              });
              return;
            }
          }
        }
      });
      let cols = this.templateData.TemplateContent.Controls
      cols = cols.filter(e => e.Property.Title[0].Text !== "申请内容")
      this.templateData.TemplateContent.Controls = [...cols,...tableData]
      // console.log(that.fromData)
      // console.log(tableData)
      // console.log("DEBUG")
      // let a = true
      // if (a) return

      this.isDisabled=true;
      var SummaryList = [];
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];

      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请人："+" "+ this.logInfo.EmpName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请部门："+" "+ this.logInfo.DeptName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请时间："+" "+ dateTime ,"Lang":"zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "附件"){
          item.IsShow = true;
        }
      })

      //提交
      submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 100,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 100);
          })
          .catch(err => {
            this.isDisabled=false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
      setTimeout(() => {
        this.templateData.TemplateContent.Controls.forEach(item => {
          if (item.Property.Title[0].Text === "附件"){
            item.IsShow = false;
          }
        })
      },100)
    },
  },
};
</script>

<style scoped>

</style>